import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EDIT_ANNOUNCEMENT_COMPONENT_CONSTS } from '@app/config/constants';
import { AddAnnouncementComponent } from '../add-announcement/add-announcement.component';
import { IAnnouncements } from '@app/services/admin/announcement-maintenance/announcement-maintenance.service';

@Component({
  selector: 'app-edit-announcement',
  templateUrl: './edit-announcement.component.html',
  styleUrls: ['./edit-announcement.component.css'],
  providers: [DatePipe]
})
export class EditAnnouncementComponent extends AddAnnouncementComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<any>,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    private datePipe: DatePipe
  ) {
    super(dialogRef, fb, data);
  }

  consts = EDIT_ANNOUNCEMENT_COMPONENT_CONSTS;
  announcement: IAnnouncements;

  ngOnInit(): void {
    super.ngOnInit();

    this.announcement = this.data.announcement;
    this.editForm.setValue({
      team: this.data.permissionLeaveName,
      message: this.announcement.message,
      link: this.announcement.link,
      isTopBanner: this.announcement.isTopBanner,
      startDateDatePart: this.datePipe.transform(this.announcement.startDate, 'yyyy-MM-dd'),
      startDateHourPart: this.datePipe.transform(this.announcement.startDate, 'HH:mm'),
      endDateDatePart: this.datePipe.transform(this.announcement.endDate, 'yyyy-MM-dd'),
      endDateHourPart: this.datePipe.transform(this.announcement.endDate, 'HH:mm')
    });
  }

  sendAnnouncement() {
    this.prepareValidator();

    if (!this.editForm.invalid && this.isDateRangeValid()) {
      let notification = this.populateNotification();
      if (this.announcement) {
        notification.createdAt = this.announcement.createdAt;
        notification.announcementID = this.announcement.announcementID;
      }
      this.dialogRef.close(notification);
    }
  }
}
